import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard/cargas-paradas-tps`

const CargasParadasTpsHttp = {
  async getCargasParadasTps(companyGroupIds, tpsIds) {
    try {
      const url = BASE_URL + `?tps_ids=${tpsIds}&company_group_id=${companyGroupIds}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default CargasParadasTpsHttp
